import { SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
class ProductService {
  DoGetProductTemplateCodeByProductIdList(productTemplateIdList: Array<number>) {
    const _input = {
      productTemplateIdList: productTemplateIdList,
    };
    return service.peakExportAPI
      .post("/api/Product/GetProductTemplateCodeByProductIdList", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new ProductService();
